<div fxLayout="column" class="dialog-container">
    <!-- Header -->
    <div fxLayout="row" fxLayoutAlign="space-between center" class="dialog-header">
        <h1 class="dialog-title">{{versionId !== '0' ? version?.VersionName : 'New Version'}}</h1>
        <button mat-icon-button (click)="close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Tabs -->
    <mat-tab-group animationDuration="0ms" class="dialog-tabs" mat-stretch-tabs="false" mat-align-tabs="start"
        [(selectedIndex)]="selectedTabIndex">
        <!-- Tab 1 -->
        <mat-tab label="Details">
            <div class="tab-content">
                <app-version-details [versionId]="versionId" [fromVersionId]="fromVersionId" [eventId]="eventId"
                    [storesToVersion]="selectedStores" (versionDetails)="onVersionDetails($event)"
                    (closeDialog)="closeDialog($event)"></app-version-details>
            </div>
        </mat-tab>

        <!-- Tab 2 -->
        <mat-tab *ngIf="versionId !== '0'" label="Stores">
            <div class="tab-content">
                <app-version-store-list [versionId]="versionId" [eventId]="eventId"
                    (moveToNewVersion)="onMoveToNewVersion($event)" (actionType)="updateActionType($event)"
                    (closeDialog)="closeDialog($event)"></app-version-store-list>
            </div>
        </mat-tab>

        <!-- Tab 3 -->
        <mat-tab *ngIf="versionId !== '0'" label="Assets">
            <div class="tab-content">
                <app-version-asset-list [versionId]="versionId" [eventId]="eventId"
                    (closeDialog)="closeDialog('cancelled')"></app-version-asset-list>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>